import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CardContentComponent } from '../../../shared/components/card/card-content.component';
import { CardHeaderComponent } from '../../../shared/components/card/card-header.component';
import { CardTitleComponent } from '../../../shared/components/card/card-title.component';
import { CardComponent } from '../../../shared/components/card/card.component';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

interface ReportLink {
  path: string;
  labelKey: string;
  descriptionKey: string;
}

/** `/reports` hub — a card per report (design doc §8). */
@Component({
  selector: 'app-reports-home',
  standalone: true,
  imports: [RouterLink, CardComponent, CardHeaderComponent, CardTitleComponent, CardContentComponent, IconComponent, TranslatePipe],
  templateUrl: './reports-home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './reports-home.component.css',
})
export class ReportsHomeComponent {
  readonly reports: ReportLink[] = [
    { path: '/reports/daily-activity', labelKey: 'reports.home.dailyActivity', descriptionKey: 'reports.home.dailyActivityDesc' },
    { path: '/reports/rate-trends', labelKey: 'reports.home.rateTrends', descriptionKey: 'reports.home.rateTrendsDesc' },
    { path: '/reports/lead-summary', labelKey: 'reports.home.leadSummary', descriptionKey: 'reports.home.leadSummaryDesc' },
    { path: '/reports/objection-breakdown', labelKey: 'reports.home.objectionBreakdown', descriptionKey: 'reports.home.objectionBreakdownDesc' },
    { path: '/reports/funnel', labelKey: 'reports.home.funnel', descriptionKey: 'reports.home.funnelDesc' },
    { path: '/reports/appointment-schedule', labelKey: 'reports.home.appointmentSchedule', descriptionKey: 'reports.home.appointmentScheduleDesc' },
    { path: '/reports/lead-export', labelKey: 'reports.home.leadExport', descriptionKey: 'reports.home.leadExportDesc' },
  ];
}
